// React
import React, { useCallback, useRef, useMemo } from "react";
// Helpers
import { size } from "@mefisto/utils";
// Framework
import { usePortal } from "stack/core";
import { HeaderItem } from "layout/header";
// Components
import HeaderButton from "./components/HeaderButton";
import HeaderPopover from "./components/HeaderPopover";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const LocalizationHeaderItem = () => {
  // Framework
  const { localization } = usePortal();
  // Ref
  const popoverRef = useRef();
  // Memo
  const enabled = useMemo(() => {
    return size(localization.availableLanguages) > 1;
  }, [localization]);
  // Callbacks
  const handleOpen = useCallback((event) => {
    popoverRef.current.open({ anchorEl: event.currentTarget });
  }, []);
  const handleSelection = useCallback(
    ({ locale }) => {
      popoverRef.current.close();
      localization.setLocale(locale);
    },
    [localization]
  );
  // Render
  return (
    <>
      {enabled && (
        <HeaderItem value="language">
          <HeaderButton onClick={handleOpen} />
          <HeaderPopover ref={popoverRef} onSelection={handleSelection} />
        </HeaderItem>
      )}
    </>
  );
};

export default LocalizationHeaderItem;
